// extracted by mini-css-extract-plugin
export var list = "verticalBoxList-module--list--zTzDC";
export var horizontal = "verticalBoxList-module--horizontal--PEUlY";
export var fadeIn = "verticalBoxList-module--fadeIn--vH-wg";
export var slideIn = "verticalBoxList-module--slideIn--o9u+W";